// Store observável mínimo (subscribe/publish), sem framework — ver design.md decisão 1.
// Cada slice é independente para não forçar re-render de tudo a cada update.
function createSlice(initialValue) {
  let value = initialValue;
  const listeners = new Set();

  return {
    get() {
      return value;
    },
    set(next) {
      value = typeof next === "function" ? next(value) : next;
      for (const listener of listeners) listener(value);
    },
    subscribe(listener) {
      listeners.add(listener);
      listener(value);
      return () => listeners.delete(listener);
    },
  };
}

export const store = {
  // Map<agentName, { state, lastExecutionAt, successRate24h, escalationRate24h, avgLatencyMs, updatedAt }>
  agentHealth: createSlice(new Map()),
  // Map<questId, human_approvals row>
  pendingQuests: createSlice(new Map()),
  // { ordersToday, revenueToday, avgProductionHours, approvalRate } | null enquanto carrega
  metrics: createSlice(null),
  // Array<{ id, severity, component, message, createdAt }>
  systemAlerts: createSlice([]),
  // sessão Supabase Auth atual, ou null
  session: createSlice(null),
  // fila de toasts ativos: Array<{ id, severity, message, createdAt }>
  toasts: createSlice([]),
  // agentName selecionado para o drawer de detalhes, ou null
  selectedAgent: createSlice(null),
  // { connected: boolean, lastEventAt: number|null } por canal Realtime
  realtimeStatus: createSlice({ agentHealth: false, humanApprovals: false }),
};
